export default "__VITE_ASSET__D9Pta$tq__"